import { Http } from './http';
import {
  CreditCrop,
  Crop,
  CxCredit,
  State,
  CxSet,
  CxReceipt,
  CreditFarm,
  CreditCall, CxCreditQuestion, CxHistory,
} from '@types';

class CxHttp extends Http {
  prefix = 'cx';

  async export(queryParams: any): Promise<CxCredit[]> {
    const res = await this.get<CxCredit[]>('/export', {
      params: queryParams,
    });

    return res.data;
  }

  async downloadInsuranceFiles(creditId: number, creditCode: string) {
    await this.downloadZip(
      `/${creditId}/download-insurance-files`,
      `Policy Insurances of Credit ${creditCode}.zip`,
    );
  }

  async downloadInsurances(creditId: number, creditCode: string) {
    await this.downloadZip(
      `/${creditId}/download-insurances`,
      `Policy Insurances of Credit ${creditCode}.zip`,
    );
  }

  async downloadCreditInvoices(creditInvoiceId: number, creditCode: string) {
    await this.downloadZip(
      `/${creditInvoiceId}/download-credit-invoices`,
      `Invoices of Credit ${creditCode}.zip`,
    );
  }

  async getOptions(): Promise<CxOptions> {
    const res = await this.get<CxOptions>('/options');

    return res.data;
  }

  async getInsurances(creditId: number): Promise<CreditCrop[]> {
    const res = await this.get<CreditCrop[]>(`/${creditId}/insurances`);

    return res.data;
  }

  async getFollowUpCalls(creditId: number): Promise<CxFollowUp> {
    const res = await this.get<CxFollowUp>(`/${creditId}/follow-up-calls`);

    return res.data;
  }

  async getCxCredit(creditId: number): Promise<CxCredit> {
    const res = await this.get<CxCredit>(`/${creditId}`);

    return res.data;
  }

  async updateInsurances(creditId: number, insurances: CreditCrop[]): Promise<CreditCrop[]> {
    const res = await this.put<CreditCrop[]>(`/${creditId}/insurances`, { insurances });

    return res.data;
  }

  async partSetsUpdate(id: number, params: any): Promise<CxSet[]> {
    const res = await this.put<CxSet[]>(`/${id}/sets`, params);

    return res.data;
  }

  async generateReceipt(id: number) {
    const res = await this.post(`/${id}/generate-receipt`);

    return res.data;
  }

  async getLastReceipt(id: number): Promise<CxReceipt> {
    const res = await this.get<CxReceipt>(`/${id}/get-last-receipt`);

    return res.data;
  }

  async downloadReceipts(creditId: number, creditCode: string) {
    await this.downloadZip(
      `/${creditId}/download-receipts`,
      `Credit ${creditCode} receipts.zip`,
    );
  }

  async getLastReceiptPreview(url: string) {
    const res = await this.get(url);

    return res.data;
  }

  async updateFieldReport(creditId: number, farms: CreditFarm[], creditAmount: number) {
    const res = await this.put('/update-field-report', { creditId, farms, creditAmount });

    return res.data;
  }

  async getHistory(creditId: number) {
    const res = await this.get<CxHistory[]>(`/${creditId}/history`);

    return res.data;
  }
}

export const cxHttp = new CxHttp();

export interface CxOptions {
  crops: Crop[];
  states: State[];
}

export interface CxFollowUp {
  calls: CreditCall[];
  questions: CxCreditQuestion[];
}
